import clsx from 'clsx';

import classes from './Spinner.module.css';

type TSpinnerVariant =
  | 'PRIMARY'
  | 'SECONDARY'
  | 'OUTLINE'
  | 'ERROR'
  | 'REMOVE'
  | 'ACTION'
  | 'ACTION_SECONDARY'
  | 'OUTLINE_SECONDARY';

type TSpinnerSize = 'SM' | 'BASE';

export type SpinnerProps = {
  className?: string;
  'data-testid'?: string;
  size?: TSpinnerSize;
  variant?: TSpinnerVariant;
};

export default function Spinner({
  className,
  'data-testid': dataTestId,
  variant,
  size,
}: SpinnerProps) {
  return (
    <div
      className={clsx(
        classes.root,
        {
          [classes.primary]: variant === 'PRIMARY',
          [classes.secondary]: variant === 'SECONDARY',
          [classes.outline]: variant === 'OUTLINE',
          [classes.error]: variant === 'ERROR',
          [classes.remove]: variant === 'REMOVE',
          [classes.outline_secondary]: variant === 'OUTLINE_SECONDARY',
          [classes.action]: variant === 'ACTION',
          [classes.action_secondary]: variant === 'ACTION_SECONDARY',
          [classes.sm]: size === 'SM',
        },
        className
      )}
      data-testid={dataTestId || 'spinner'}
    />
  );
}
